import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import {
    CreditUnionWithRole,
    CurrentCreditUnion
} from "../models/credit-union-portal.model";

@Injectable({ providedIn: 'root' })
export class CreditUnionPortalEndpoint {
    private readonly http = inject(HttpClient);

    private readonly endpoints = {
        creditUnions: 'credit-unions',
        creditUnion: 'credit-union'
    };

    getCreditUnions(): Observable<CreditUnionWithRole[]> {
        return this.http.get<CreditUnionWithRole[]>(this.endpoints.creditUnions);
    }

    getCurrentCreditUnion(): Observable<CurrentCreditUnion> {
        return this.http.get<CurrentCreditUnion>(this.endpoints.creditUnion);
    }
}
